import WidgetSearchField from "../../../widgets/widget-search-field";
import Api from "../../../lib/api";

export default class CoachesSearch {
	constructor({ $root, afterFetch } = {}) {
		this.$root = $root;
		this.$searchField = null;
		this.$coachesListContainer = null;

		this.afterFetch = afterFetch;
		this.searchUrl = `${craft.env.apiSiteUrl}/feed/coaches?cityId=${craft.env.cityId}`;
		this.searchField = null;

		this.init();
	}

	init() {
		if (!this.$root) {
			return;
		}

		this.$searchField = this.$root.querySelector('.block-coaches-search_input');
		this.$coachesListContainer = this.$root.querySelector('.block-coaches-search_list');

		this.searchField = new WidgetSearchField({ $root: this.$searchField });
		this.addEventListeners();
	}

	addEventListeners() {
		let timeoutId;

		/* @var detail: string (searchQuery) */
		this.searchField.subscribe('searchInput', ({ detail }) => {
			this.setState('loading');

			if (!detail.length) {
				this.setState('initial');
				return;
			}

			if (timeoutId) {
				clearTimeout(timeoutId);
			}

			timeoutId = setTimeout(() => {
				this.search(detail);
			}, 500);
		});
	}

	search(value) {
		Api.get(this.searchUrl, { query: value })
			.then((data) => {
				if (data && data.trim()) {
					this.$coachesListContainer.innerHTML = data.trim();
					lozadObserver.observe();
					this.setState('found');

					if (this.afterFetch && typeof this.afterFetch === 'function') {
						const $coachItems = this.$coachesListContainer.querySelectorAll('.coach-card');
						this.afterFetch($coachItems)
					}
				} else {
					this.setState('not-found');
				}
			});
	}

	setState(type) {
		switch (type) {
			case 'initial':
				this.$coachesListContainer.innerHTML = '';
				this.$root.classList.remove('-active');
				this.$root.classList.remove('-not-found');
				this.$root.classList.remove('-loading');
				break;
			case 'loading':
				this.$root.classList.remove('-not-found');
				this.$root.classList.add('-active');
				this.$root.classList.add('-loading');
				break;
			case 'not-found':
				this.$root.classList.remove('-loading');
				this.$root.classList.add('-not-found');
				break;
			case 'found':
				this.$root.classList.remove('-not-found');
				this.$root.classList.remove('-loading');
				break;
		}
	}
}